// Resolves a joybird orientation selection to the orientation `code` Cylindo expects.
// Most products send a plain side ("Left"), but reclining ones send the seat count too
// ("1 Recliner Left") while Cylindo still only publishes LEFT and RIGHT. Try an exact
// match first, then fall back to the side word on its own.
const resolveCylindoOrientationCode = ({ jbValue, cylindoOptions } = {}) => {
  if (!Array.isArray(cylindoOptions) || cylindoOptions.length === 0) {
    return null;
  }

  const normalizedValue = String(jbValue || '')
    .trim()
    .toLowerCase();
  if (!normalizedValue) {
    return null;
  }

  const normalizedCode = code =>
    String(code)
      .trim()
      .toLowerCase();

  const exact = cylindoOptions.find(
    opt => opt.code != null && normalizedCode(opt.code) === normalizedValue
  );
  if (exact) return exact.code;

  const side = /\b(left|right)\b/.exec(normalizedValue)?.[1];
  if (side) {
    const bySide = cylindoOptions.find(
      opt => opt.code != null && normalizedCode(opt.code) === side
    );
    if (bySide) return bySide.code;
  }

  return null;
};

export default resolveCylindoOrientationCode;
